// ** React Imports
import React, { Fragment, useState } from 'react';
import axiosInstance from '../../../../network/axios.instance';
// ** Dropdowns Imports
import IntlDropdown from './IntlDropdown';
import CartDropdown from './CartDropdown';
import UserDropdown from './UserDropdown';
import NavbarSearch from './NavbarSearch';
import NotificationDropdown from './NotificationDropdown';
import LogoLight from '@src/assets/images/the-club/logo/sae-favicon-256-white-no-bg.png';
import LogoDark from '@src/assets/images/the-club/logo/SAE_single_white.png';

// ** Custom Components
import NavbarBookmarks from './NavbarBookmarks';
import Autocomplete from '@components/autocomplete';

// ** Third Party Components
import { Sun, Moon, AlertCircle } from 'react-feather';
import { NavItem, NavLink, Label, Input } from 'reactstrap';
import axios from 'axios';
import classnames from 'classnames';
import PerfectScrollbar from 'react-perfect-scrollbar';
import * as Icon from 'react-feather';

import data from './data';
import SearchInput from '../../../components/search-input';

// axios.defaults.headers.get['Content-Type'] = 'application/json;charset=utf-8'
// axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*'

let cancelToken;

const ThemeNavbar = (props) => {
  // ** Props
  const { skin, setSkin, setMenuVisibility } = props;

  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [activeSuggestion, setActiveSuggestion] = useState(null);
  const [loading, setLoading] = useState(false);

  // ** Function to toggle Theme (Light/Dark)
  // const ThemeToggler = () => {
  //   if (skin === 'dark') {
  //     return <Sun className='ficon' onClick={() => setSkin('light')} />;
  //   } else {
  //     return <Moon className='ficon' onClick={() => setSkin('dark')} />;
  //   }
  // };

  const searchAddress = async (text) => {
    let fetchedData = [];
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.');
    }
    //Save the cancel token for the current request
    cancelToken = axios.CancelToken.source();
    if (text.length > 0) {
      await axios
        .get(`https://meta.theclubguild.com/elastic/suggest-both/?q=${text.toLowerCase()}&limit=12`,
           {
            cancelToken: cancelToken.token,
          }
        )
        .then((res) => {
          fetchedData = res.data;
        })
        .catch((err) => {
          fetchedData = data;
        });
    }

    const newData =
      fetchedData?.result?.hits?.hits?.length > 0
        ? fetchedData?.result?.hits?.hits?.map((item) => {
          return item._source;
        })
        : [];

    setSuggestions(newData);
    setShowSuggestions(true);
    setLoading(false);
  };

  const search = (text) => {
    setLoading(true);
    searchAddress(text);
  };

  const clearInput = () => {
    setSuggestions([]);
    setLoading(false);
    setShowSuggestions(false);
  };
  return (
    <Fragment>
      <div className='bookmark-wrapper d-flex align-items-center search-input-wrapper'>
        {window?.innerWidth < 1200 ? (
          <a href='/'>
            <img
              src={skin === 'dark' ? LogoLight : LogoDark}
              alt='the club'
              height={window.innerWidth < 576 ? '40px' : '50px'}
              className='d-block'
              style={{ marginRight: '8px', marginLeft: '-10px' }}
            />
          </a>
        ) : null}
        <SearchInput
          // autoFocus={window.innerWidth < 600 ? false : true}
          suggestions={suggestions}
          filterKey={'address'}
          placeholder='Search'
          onChange={(e) => search(e.target.value)}
          loading={loading}
          style={{ minWidth: '160px' }}
          clearInput={clearInput}
        />
      </div>
      <ul
        className='nav navbar-nav flex-nowrap align-items-center'
        style={{ marginLeft: '4px' }}
      >
        {/* <IntlDropdown /> */}
        {/* <NavItem className='d-block ml-1'>
          <NavLink className='nav-link-style'>
            <ThemeToggler />
          </NavLink>
        </NavItem> */}
        <NavbarBookmarks setMenuVisibility={setMenuVisibility} />
        {/* <NavbarSearch />
        <CartDropdown />
        <NotificationDropdown />
        <UserDropdown />  */}
        {/*<NavbarSearch />*/}
      </ul>
    </Fragment>
  );
};

export default ThemeNavbar;
